import type { CSSProperties } from 'react'
import { cn } from '@/lib/utils'

/**
 * Значок промпта для AI — оранжевая звёздочка, та же, что у раздела «Использование»
 * в профиле. Нарисована прямо в разметке, а не отдельным файлом-картинкой: иначе на
 * открытии страницы значок появлялся с задержкой, пока догружался файл.
 * Цвет — фирменный оранжевый (иллюстрация, а не тема приложения).
 */
export const AiPromptIcon = ({
  className,
  style,
}: {
  className?: string
  style?: CSSProperties
}) => (
  <svg
    viewBox="0 0 121 121"
    aria-hidden="true"
    className={cn('size-4 shrink-0', className)}
    style={style}
  >
    <path
      d="M58.8855 1.43422C59.1126 -0.478074 61.8874 -0.478074 62.1145 1.43422L64.018 17.4767C66.476 38.1918 82.8083 54.524 103.523 56.982L119.566 58.8855C121.478 59.1126 121.478 61.8874 119.566 62.1145L103.523 64.018C82.8083 66.476 66.476 82.8083 64.018 103.523L62.1145 119.566C61.8874 121.478 59.1126 121.478 58.8855 119.566L56.982 103.523C54.524 82.8083 38.1918 66.476 17.4767 64.018L1.43422 62.1145C-0.478074 61.8874 -0.478074 59.1126 1.43422 58.8855L17.4767 56.982C38.1918 54.524 54.524 38.1918 56.982 17.4767L58.8855 1.43422Z"
      fill="#FF8645"
    />
  </svg>
)
